// pothos manager «Обзор» v2 (хэндофф 2026-07-19) — /api/getManagerOverviewBoard.
// Всё из каталога pothos_assets: ready = status accepted (прошло QA, не
// отгружено), «дойдёт» = status qa, in_flight = uploaded/in_work.
// plan_remaining = остаток плана locale_limits минус отгруженное каталога
// (недельного плана в данных нет — «из N плана» это остаток общего плана).
// Матрица «Текущая отгрузка» = accepted по странам × (категория × вид).
import { z } from 'zod';
import { PothosShipReadinessSchema } from './manager-assets';

export const PothosOverviewCatSchema = z.object({
  key: z.enum(['member', 'event', 'coupon', 'gift']),
  ready: z.number(),
  qa: z.number(),
  target: z.number(),
});

export const PothosOverviewDeptReadySchema = z.object({
  key: z.enum(['it', 'photographer', 'scraper', 'upwork', 'designer', 'other']),
  ready: z.number(),
});

export const PothosOverviewMatrixRowSchema = z.object({
  country_iso: z.string(),
  country: z.string(),
  priority: z.string(),
  cells: z.object({
    ticket_s: z.number(), ticket_p: z.number(),
    gift_s: z.number(), gift_p: z.number(),
    member_s: z.number(), member_p: z.number(),
    coupon_s: z.number(), coupon_p: z.number(),
  }),
});
export type PothosOverviewMatrixRow = z.infer<typeof PothosOverviewMatrixRowSchema>;

export const PothosManagerOverviewBoardResSchema = z.object({
  hero: z.object({
    ready: z.number(),
    qa: z.number(),
    in_flight: z.number(),
    potential: z.number(),
    plan_remaining: z.number(),
    cats: z.array(PothosOverviewCatSchema),
  }),
  ship_depts: z.array(PothosOverviewDeptReadySchema),
  matrix: z.array(PothosOverviewMatrixRowSchema),
  // Сколько из `accepted` реально уйдёт в архив, и что держит остальное.
  // Считается на сервере тем же правилом, каким сборка судит строку в браузере
  // (`SHIP_READY_SQL` ↔ `ShipmentReadyRowSchema`).
  ship_ready: PothosShipReadinessSchema,
});
export type PothosManagerOverviewBoardRes = z.infer<typeof PothosManagerOverviewBoardResSchema>;
